"use client"

import { ConnectWalletButton } from "@shared/web3"

import { LocaleSwitcher } from "@/features/i18n/locale-switcher"
import { useTranslations } from "@/lib/i18n/client"
import { useWalletLabels } from "@/lib/wallet-labels"
import { navLinks } from "@/lib/live-data"

export function SiteHeader() {
  const t = useTranslations("header")
  const walletLabels = useWalletLabels()

  return (
    <header className="sticky top-0 z-40 border-b border-brand bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-4">
        <a href="#" className="text-lg font-semibold tracking-tight text-brand">
          {t("brand")}
        </a>

        <nav className="hidden items-center gap-6 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.key}
              href={link.href}
              className="text-sm font-medium text-muted-foreground transition-colors hover:text-brand"
            >
              {t(`nav.${link.key}`)}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <LocaleSwitcher />
          <ConnectWalletButton
            connectLabel={t("connectWallet")}
            disconnectLabel={walletLabels.disconnect}
            labels={walletLabels}
            size="sm"
          />
        </div>
      </div>
    </header>
  )
}
